
























import { Component, Vue, Prop } from 'vue-property-decorator'
import { projectListLocalisationKeys } from '@/features/projectList/projectList.localisation'

@Component
export default class NextBtn extends Vue {
  private translationsProjectLsit = projectListLocalisationKeys
  @Prop()
  nextPage!: string
  @Prop()
  readonly isDisable!: boolean
  @Prop()
  readonly warningText!: string

  private goToNext () {
    this.$router.push({ name: this.nextPage })
  }
}
